import { render, staticRenderFns } from "./BasicInformation.vue?vue&type=template&id=7dcebac4"
import script from "./BasicInformation.vue?vue&type=script&lang=js"
export * from "./BasicInformation.vue?vue&type=script&lang=js"
import style0 from "./BasicInformation.vue?vue&type=style&index=0&id=7dcebac4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports